import {currentUser, apiUrl} from '@/constants/config';
import axios from 'axios';

export default {
    state: {
        currentUser: (localStorage.getItem('user') != null) ? JSON.parse(localStorage.getItem('user')) : null,
        token: (localStorage.getItem('token') != null) ? localStorage.getItem('token') : null,
        loginError: null,
        processing: false
    },
    getters: {
        currentUser: state => state.currentUser,
        token: state => state.token,
        processing: state => state.processing,
        loginError: state => state.loginError
    },
    mutations: {
        setUser(state, payload) {
            state.currentUser = payload;
            state.token = payload.token;
            state.processing = false;
            state.loginError = null;
        },
        setLogout(state) {
            state.currentUser = null;
            state.processing = false;
            state.loginError = null;
        },
        setProcessing(state, payload) {
            state.processing = payload;
            state.loginError = null;
        },
        setError(state, payload) {
            state.loginError = payload;
            state.currentUser = null;
            state.processing = false;
        },
        clearError(state) {
            state.loginError = null;
        }
    },
    actions: {
        login({commit}, payload) {
            commit('clearError');
            commit('setProcessing', true);

            return new Promise((resolve, reject) => {
                axios.post(apiUrl + 'auth/local/', payload).then(response => {
                    response.data.user.token = response.data.token;
                    localStorage.setItem('token', response.data.token);
                    localStorage.setItem('user', JSON.stringify(response.data.user));

                    axios.defaults.headers.common['Authorization'] = response.data.token;

                    commit('setUser', response.data.user);
                }, err => {
                    commit('setError', err.response.data);
                    localStorage.removeItem('token');
                    reject(err.response.data);
                });
            });
        },
        signOut({commit}) {
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            commit('setLogout');
        },

        updateUser({}, payload) {
            return new Promise((resolve, reject) => {
                axios.put(apiUrl + 'api/user/' + payload.id, payload.data).then(response => {
                    resolve(response.data);
                }, err => {
                    console.log(err);
                    reject(err.response.data);
                });
            });
        },

        makeLoginRequest({}, payload) {
            return new Promise((resolve, reject) => {
                axios.post(apiUrl + 'api/user/login', payload).then(response => {
                    resolve(response.data);
                }, err => {
                    console.log(err);
                    reject(err.response.data);
                });
            });
        },

        getRecords({}, secret) {
            return new Promise((resolve, reject) => {
                axios.get(apiUrl + 'api/user/records/' + secret).then(response => {
                    resolve(response.data);
                }, err => {
                    console.log(err);
                    reject(err.response.data);
                });
            });
        }
    }
}
